module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [(_vm.image) ? _c('div', {
    staticClass: "car-image-wrapper",
    on: {
      "click": function($event) {
        _vm.image = null
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "floating-top-banner-mobile animated fadeInDown delay-1s",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (mobile banner)')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/partners/samlino-mobile-banner2.jpg"
    }
  })]), _vm._v(" "), _c('top-menu'), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.$store.state.searching && _vm.$store.state.match) ? _c('div', {
    staticClass: "floating-partner animated fadeInLeft delay-5s floating-partner__left",
    on: {
      "click": function($event) {
        _vm.goToInsurancePartner('Samlino (banner)')
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.searching && _vm.$store.state.match) ? _c('div', {
    staticClass: "floating-partner animated fadeInRight delay-5s floating-partner__right",
    on: {
      "click": function($event) {
        _vm.goToBroadbandPartner('Fastspeed (banner)')
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.$store.state.match) ? _c('router-view', {
    staticClass: "animated fadeIn"
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.searching && !_vm.$store.state.match) ? _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n                Vi fandt desværre ingen resultater på din søgning.\n                "), _c('br'), _c('br'), _vm._v("\n                Tjek venligst, at du har indtastet de korrekte oplysninger og prøv igen.\n                "), _c('br'), _c('br'), _vm._v("\n                Har du indtastet den korrekte nummerplade, er det muligt, at et af registrene ikke svarer.\n                "), _c('br'), _vm._v("\n                Vi beder dig derfor prøve igen senere og beklager ulejligheden.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.searching) ? _c('div', {
    staticClass: "loader-spinner"
  }, [(_vm.$store.state.searching) ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_vm._m(2)]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('foo')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": "/static/partners/samlino-high-banner.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": "/static/partners/fastspeed_high_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e288fb6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/index.vue
// module id = 362
// module chunks = 1